export const TOKEN_ACCESS = 'accessToken';
export const TOKEN_REFRESH = 'refreshToken';

export const TOKEN_INTEGRACAO = 'INTEGRACAO';
